<template>
  <div class="container-fluid" v-if="school && department && program">
    <div class="row">
      <div class="col col-expand">
        <h2>
          {{ department.name }}{{ program.name }} - {{ department.startYear }} ({{program.numberOfStudents}})
        </h2>
      </div>
      <!-- <div class="col col-auto" v-if="userProfile && userProfile.role && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
                 <button class="btn btn-info btn-sm mr-2" @click="$router.push({ name: 'IStudentsAdd', params: { schoolId: schoolId, departmentId: departmentId, programId: program.id} })">Сурагч нэмэх</button>
            </div> -->
      <div
        class="col col-auto"
        v-if="
          userProfile &&
          userProfile.role &&
          (userProfile.role == 'admin' ||
            userProfile.role == 'sts' ||
            userProfile.role == 'manager' ||
            userProfile.role == 'teacher')
        "
      >
        <button
          class="btn btn-danger btn-sm mr-2"
          @click="
            $router.push({
              name: 'ProgramStudentAdd',
              params: {
                schoolId: schoolId,
                departmentId: departmentId,
                programId: program.id,
              },
            })
          "
        >
          Сурагч нэмэх
        </button>
        <!-- 
        <button class="btn btn-danger btn-sm mr-2" @click="_letGraduate">
          Сурагч төгсгөx
        </button> -->
      </div>

      <!-- <div class="col col-auto">
                <button @click="deleteAll" class="btn btn-sm btn-danger" title="Бүx сурагчдыг устгаx">Бүx cурагчдыг устгах</button>
            <div class="col col-auto" v-if="userProfile && userProfile.role && (userProfile.role=='admin' || userProfile.role=='sts' || userProfile.role=='manager')">
                 <button class="btn btn-info btn-sm mr-2" @click="$router.push({ name: 'IStudentsAdd', params: { schoolId: schoolId, departmentId: departmentId, programId: program.id} })">Сурагч нэмэх</button>
            </div>
  -->
    </div>
    <div class="card shadow my-4">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h6 class="m-0 font-weight-bold text-primary">
              Сурагчдын жагсаалт
              <span
                v-if="
                  students != undefined &&
                  students != null &&
                  students.length > 0
                "
                >({{ students.length }})</span
              >
            </h6>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div
          class="table-responsive"
          v-if="students != null && students.length > 0"
        >
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th>№</th>
                <th>Овог/Нэр</th>
                <th>Имэйл</th>
                <th>Сурагчын код</th>
                <th>Регистр</th>
                <th>Хүйс</th>
                <th>Төлөв</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(student, index) in students" v-bind:key="student.id">
                <td>{{ index + 1 }}</td>
                <td>
                  <span
                    class="font-weight-bold"
                    v-if="student.lastname && student.lastname.length > 0"
                  >
                    <span
                      v-if="
                        student.lncount &&
                        student.lncount > 1 &&
                        student.lastname.length >= student.lncount
                      "
                      >{{
                        student.lastname.substring(0, student.lncount)
                      }}</span
                    >
                    <span v-else>{{ student.lastname[0] }}</span
                    >.
                  </span>
                  {{ student.name }}
                </td>
                <td>{{ student.email }}</td>
                <td>{{ student.code }}</td>
                <td>{{ student.register }}</td>
                <td>
                  <div
                    v-if="student.gender != null && student.gender != undefined"
                  >
                    <span v-if="student.gender == 0">эрэгтэй</span>
                    <span v-if="student.gender == 1">эмэгтэй</span>
                  </div>
                </td>
                <td>
                  <span
                    v-if="student.user == null || student.user == undefined"
                    class="badge notinsystem"
                    >Системд холбогдоогүй</span
                  >
                  <span v-else class="badge badge-success"
                    >Системд холбогдсон</span
                  >
                </td>
                <!-- <td style="width:4%">{{ student.learningType }}</td> -->
                <td>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="_exitedSchool(student)"
                    title="Сургуульд байxгүй"
                  >
                    xасаx
                  </button>
                  <button
                    class="btn btn-danger btn-sm ml-1"
                    @click="_moveStudent(student)"
                    title="Өөр анги руу шилжүүлэx"
                  >
                    шилжүүлэx
                  </button>
                  <button
                    class="btn btn-primary btn-sm"
                    @click="
                      $router.push({
                        name: 'StudentDetail',
                        params: { schoolId: schoolId, studentId: student.id },
                      })
                    "
                  >
                    харах
                  </button>

                  <button
                    class="btn btn-warning btn-sm ml-1"
                    @click="_edit(student)"
                  >
                    засах
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info text-center">
          Одоогоор сурагчдын мэдээлэл ороогүй байна.
        </div>
      </div>
    </div>

    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div
      class="modal fade"
      id="moveStudent"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      aria-labelledby="leaderModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="leaderModalLabel">Сурагч шилжүүлэx</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body" v-if="selectedStudent">
            <form action="">
              <div class="form-group">
                    <div class="col">
                  <div class="form-group">
                Сурагч: <span class="font-weight-bold">{{ selectedStudent.name }}</span> <span>, {{selectedStudent.lastname}}</span>
               
                  </div>
                    </div>
                <div class="col">
                  <div class="form-group">
 
                    <label for="exampleFormControlSelect1">Анги сонгоx (<small class="text-danger">шилжүүлэx анги, бүлгээ сонгоно уу</small>)</label>
                    <select class="form-control" v-model="selectedDepartment">
                      <option
                        v-for="dep in departments"
                        v-bind:value="dep"
                        :key="dep.id"
                      >
                        <span class="text-uppercase">{{ dep.name }}</span>
                      </option>
                    </select>
                  </div>
                  <div class="form-group" v-if="selectedDepartment != null">
                    <label for="exampleFormControlSelect1">Бүлэг сонгоx</label>
                    <select class="form-control" v-model="selectedProgram">
                      <option
                        v-for="prog in selectedDepartment.programs"
                        v-bind:value="prog"
                        :key="prog.id"
                      >
                        {{ prog.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Цуцлаx
            </button>
            <button
              @click="_saveMoveStudent"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >
              Xадгалаx
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import myfunction from "../global/myfunction.js";
const fb = require("../../firebaseConfig.js");

export default {
  data() {
    return {
      selectedDepartment: null,
      selectedProgram: null,
      departments: null,
      students: [],
      studentsText: null,
      tmpstudents: [],
      school: null,
      department: null,
      program: null,
      loading: false,
      selectedStudent: null,
    };
  },
  props: {
    schoolId: {
      required: true,
    },
    departmentId: {
      required: true,
    },
    programId: {
      required: true,
    },
  },
  mixins: [myfunction],
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  methods: {
    _saveMoveStudent() {
      var yes = confirm(
        this.getXStudentName(this.selectedStudent) +
          " сурагчийг шилжүүлэx үйлдэл xийxийг xүсэж байна уу?"
      );
      if (yes) {
        
        var updates = {};
        updates["program-" + this.school.currentYear] = this.selectedProgram.ref
        updates["programName-" + this.school.currentYear] = this.selectedProgram.name;
        updates["department-" + this.school.currentYear] = this.selectedDepartment.ref
        updates["departmentName-" + this.school.currentYear] = this.selectedDepartment.name;
 
        this.selectedStudent.ref.update(updates).then(()=>{
          alert(this.selectedDepartment.name + this.selectedProgram.name+ ": " + "Шилжүүлэг амжилттай xийгдлээ.")
           $("#moveStudent").modal("hide");
           this.selectedStudent = null
           this.selectedProgram = null
           this.selectedDepartment = null
        })
      }
    },
    _moveStudent(student) {
      this.selectedStudent = Object.assign({}, student);
      $("#moveStudent").modal("toggle");
    },
    _exitedSchool(student) {
   
      var yes = confirm(
        this.getXStudentName(student) +
          " сурагчийг ангиасаа xасаx үйлдэл xийxийг xүсэж байна уу?"
      );
      if (yes) {
        var updates = {};
        updates["program-" + this.school.currentYear] = null;
        updates["programName-" + this.school.currentYear] = null;
        updates["department-" + this.school.currentYear] = null;
        updates["departmentName-" + this.school.currentYear] = null;
        updates["deleted"] = true
        updates["deleted-department"] = this.department.ref
        updates["deleted-program"] = this.program.ref
        console.log(updates);
        student.ref.update(updates);
      }
    },
    _letGraduate() {
      var counter = 0;
      for (var stud of this.students) {
        counter++;
        stud.ref.update({ learningType: "active", graduatedYear: null });
        console.log(stud.name);
      }
      console.log("finsihed!!!");
    },
    _readClasses() {
      this.school.ref
        .collection("departments")
        .orderBy("createdAt", "desc")
        .where("startYear", "==", this.school.currentYear)
        .get()
        .then((querySnapshot) => {
          this.departments = [];
          querySnapshot.forEach(async (doc) => {
            let department = doc.data();
            department.id = doc.id;
            department.ref = doc.ref;

            var xx = await department.ref
              .collection("programs")
              .orderBy("name", "asc")
              .get();
            console.log("STEP-1");
            if (!xx.empty) {
              department.programs = [];
              xx.docs.forEach((doc) => {
                let program = doc.data();
                program.ref = doc.ref;
                program.id = doc.id;
                department.programs.push(program);
                console.log("STEP....");
              });
            }
            console.log("STEP-end");
            this.departments.push(department);
          });
        });

      // this.school.ref
      //   .collection("departments")
      //   .where("startYear", "==", this.school.currentYear)
      //   .orderBy("createdAt", "desc")
      //   .get()
      //   .then((docs) => {
      //     this.departments = [];
      //     docs.forEach((doc) => {
      //       let dep = doc.data();
      //       dep.id = doc.id;
      //       dep.ref = doc.ref;
      //       // dep.ref
      //       //   .collection("programs")
      //       //   .get()
      //       //   .then((docs) => {
      //       //     dep.programs = [];
      //       //     docs.forEach((doc) => {
      //       //       let prog = doc.data();
      //       //       prog.ref = doc.ref;
      //       //       prog.id = doc.id;
      //       //       dep.programs.push(prog);
      //       //     });
      //       //   });
      //       this.departments.push(dep);
      //     });
      //   });
    },
    async _getData() {
      fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get()
        .then((schoolData) => {
          if (schoolData.exists) {
            let school = schoolData.data();
            school.id = schoolData.id;
            school.ref = schoolData.ref;
            this.school = school;

            this._readClasses();

            schoolData.ref
              .collection("departments")
              .doc(this.departmentId)
              .get()
              .then((depDoc) => {
                if (depDoc.exists) {
                  let dep = depDoc.data();
                  dep.id = depDoc.id;
                  dep.ref = depDoc.ref;
                  this.department = dep;

                  depDoc.ref
                    .collection("programs")
                    .doc(this.programId)
                    .get()
                    .then((proDoc) => {
                      if (proDoc.exists) {
                        let pro = proDoc.data();
                        pro.id = proDoc.id;
                        pro.ref = proDoc.ref;
                        this.program = pro;

                        var programFieldName = "program";
                        if (
                          this.department.startYear != undefined &&
                          this.department.startYear != null &&
                          this.department.startYear > 2020
                        ) {
                          programFieldName =
                            programFieldName + "-" + this.department.startYear;
                        }

                        schoolData.ref
                          .collection("students")
                          .where(programFieldName, "==", proDoc.ref)
                          .orderBy("name")
                          .onSnapshot((snapshot) => {
                            this.students = [];
                            snapshot.docs.forEach(async (doc) => {
                              if (doc.exists) {
                                let student = doc.data();
                                student.id = doc.id;
                                student.ref = doc.ref;

                                // var users = await fb.db.collection('users').where("customer","==",doc.ref).get();
                                // if(users!=null && !users.empty){
                                //     users.docs.forEach(usr=>{
                                //         if(usr.exists){
                                //            // student.email = usr.data().email;
                                //         }
                                //     })
                                // }

                                this.students.push(student);
                              }
                            });
                            this.program.ref.update({ numberOfStudents: snapshot.size});
                          });
                      }
                    });
                }
              });
          }
        });
    },
    async deleteAll() {
      var r = confirm(
        "Та энэ ангийн бүх сурагчдыг устгахдаа итгэлтэй байна уу."
      );
      if (r == true) {
        if (this.students && this.students.length > 0) {
          var batch = fb.db.batch();
          for (const student of this.students) {
            batch.delete(
              fb.db.doc("schools/" + this.schoolId + "/students/" + student.id)
            );
          }
          await batch.commit();
          this._getData();
        }
      }
    },
    _edit(student) {
      this.$router.push({
        name: "ProgramStudentAdd",
        params: { studentId: student.id },
      });
    },
  },
  created() {
    this._getData();
  },

  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>
